export * from 'server/models/MarineTrafficServiceSearch';


// WEBPACK FOOTER //
// ./data/models/MarineTrafficServiceSearch.ts